<template>
  <layout-basic>
    <v-container fluid class="mt-4">
      <v-row>
        <v-col class="Full-Course-Library-Title pt-0">
          Course Library
        </v-col>
      </v-row>
      <v-row class="course-filter my-course-filter">
        <v-col md="3" sm="12">
          <v-text-field name="search-courses" class="search-box" placeholder="Search Courses"
            prepend-icon="fa-search" v-model="search" type="text" clearable clear-icon="fa-times"
            @click:clear="clearSearch" @change="submitSearch"></v-text-field>
        </v-col>
        <v-col md="3" sm="12" class="mb-4">
        <v-select :items="categories" :clearable="true" item-text="name" item-value="id" ref="categoryFilterBox"
                placeholder="Filter course categories" multiple small-chips class="categories" v-model="selectedCategory"
                v-on:change="filterCoursesByCategories($event)" menu-props="content-class: dropdown-below" @click:clear="handleClear">
                <template v-slot:selection="{ item, index }">
                <template v-if="index < 2">
                  <v-chip :title="item.name">{{ $gf.truncateText(item.name, 6) }}</v-chip>
                </template>
                <template v-if="index === 2">
                  <v-chip>...</v-chip>
                </template>
              </template>
                <template v-slot:prepend-item>
            <v-list-item ripple @click="toggleSelectAll">
              <v-list-item-action>
                <v-checkbox :input-value="selectAll" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Select All</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
          </v-select>  
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="loading" fluid class="pt-0">
      <v-row>
        <v-col md="12" class="text-center">
          <v-layout wrap>
            <v-flex v-for="index in 9" :key="index" xs12 sm6 lg3 class="mb-5">
              <v-card :class="['card-outter', 'pb-0', { 'mr-6': isTabletOrDesktop }]" height="100%">
                <v-skeleton-loader elevation="2" class="card-loader"
                  type="list-item-two-line, image, list-item, button">
                </v-skeleton-loader>
              </v-card>
            </v-flex>
          </v-layout>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else fluid class="pt-0 pr-2">
      <v-row>
        <v-col md="12" class="pt-0">
          <v-container v-if="courses.length == 0" style="padding:0px;">
            <h2>No Courses Available.</h2>
          </v-container>
          <v-container v-else grid-list-md fluid class="pa-0">
            <v-layout wrap>
              <v-flex v-for="course in courses" :key="course.id" xs12 sm6 lg3 class="mb-5">
                <course-card :course="course" :courseLibrary="true"></course-card>
              </v-flex>
              <div v-if="courses.length" v-observe-visibility="handleScrollToBottom"></div>
            </v-layout>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from '@/layouts/Dashboard';
import courseAPI from '@/api/course.js';
import CourseCard from '@/components/global/CourseCard';

export default {
  name: 'CourseLibrary',
  components: {
    LayoutBasic,
    CourseCard,
  },
  data() {
    return {
      search: '',
      courses: {},
      loading: false,
      params: '?',
      course_status: '0',
      page: 1,
      lastPage: 1,
      requestCompleted: true,
      categories: [],
      selectedCategory: [],
    };
  },
  computed: {
    showAdmin: function() {
      return this.$store.getters.admin;
    },
    isTabletOrDesktop() {
      const width = this.$vuetify.breakpoint.width;
      return width >= 820;
    },
    selectAll() {
      return this.selectedCategory.length === this.categories.length;
    },
  },
  mounted() {
    this.loadSearch();
    this.getAllCourseCategories();
    this.listFilteredCourse();
    let self = this;
    window.addEventListener('keyup', function(event) {
      if (event.keyCode === 13) {
        self.submitSearch();
      }
    });
  },
  methods: {
    submitSearch() {
      if (this.search.trim() !== '') {
        this.listFilteredCourse();
        this.saveSearch();
      }else{
        this.clearSearch();
      }
    },
    clearSearch() {
      this.search = '';
      this.course_status = '0';
      this.params = '?';
      this.listFilteredCourse();
      this.saveSearch();
    },
    listFilteredCourse() {
      this.loading = true;
      this.searchParams = this.search && this.search.length > 0
          ? '&search=name:' + this.search
          : '';
      this.page = 1;    
       if (this.selectedCategory.length) {
        this.searchParams += '&categories=' + this.selectedCategory.toString();
       }
      courseAPI
        .getCoursesData(
          this.params,
          this.searchParams
        ).then((response) => {
          this.courses = response.data.data;
          this.loading = false;
          this.lastPage = response.data.meta.pagination.total_pages;
        });


    },
    loadMore() {
      this.requestCompleted = false;
      courseAPI
        .getCoursesData(
          this.params + 'include=thumbnail&page=' + this.page,
          this.searchParams
        )
        .then((response) => {
          this.requestCompleted = true;
          this.courses.push(...response.data.data);
          this.lastPage = response.data.meta.pagination.total_pages;
        });
    },
    handleScrollToBottom(isVisible) {
      if (!isVisible) {
        return;
      }
      if (!this.requestCompleted) {
        return;
      }
      if (this.page >= this.lastPage) {
        return;
      }
      this.page++;
      this.loadMore();
    },
    saveSearch() {
      // Save search value to localStorage
      localStorage.setItem('course-library-search', this.search);
    },
    loadSearch() {
      // Load search value from localStorage
      const savedSearch = localStorage.getItem('course-library-search');
      if (savedSearch !== null) {
        this.search = savedSearch;
      }
    },
    getAllCourseCategories() {
        courseAPI.getAllCourseCategories().then(response => {
            this.categories = response.data.data;
        });
        },
    filterCoursesByCategories(){
      this.listFilteredCourse();      
    },
    handleClear(){
      const dropdown = this.$refs.categoryFilterBox.$el;
      dropdown.style.removeProperty("overflow");
    },
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedCategory = [];
      } else {
        this.selectedCategory =  this.categories.map((cat) => cat.id);
      }
      this.listFilteredCourse()
    },
  },
};
</script>
<style scoped>
.course-filter .search-box{
  border-radius: 25px;
  max-width: unset !important;
  height: 40px;
  margin-top: 0;
}
.course-filter .categories {
  max-width: unset !important; 
}

</style>